import React, { useEffect, useRef } from "react";
import './ModalContent.less';

const ModalContent = ({ Title, Content, Link, ShowModal, SetShowModal }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        if (ShowModal) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ShowModal]);

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            SetShowModal(false);
        }
    };

    return <><div ref={modalRef} className={`modalContent right-slide-in-menu ${ShowModal ? 'wrapper-visible' : ''}`}>
        <div className="closeBtn">
            <button className="btn p-0" onClick={(e) => { SetShowModal(false); e.preventDefault() }}>
                <span><i className="le-icon-x"></i></span>
                <span className="sr-only">Close modal</span>
            </button>
        </div>

        <div className="py-5 d-flex justify-content-center flex-column">
            {Title && <h1 className="heading4 mb-0">{Title}</h1>}
        </div>
        {Content && <div className="mt-4 text-color--gray80 paragraph--s"><Content /></div>}
        {Link && <div className="mt-6 link"><Link /></div>}
    </div>
        {ShowModal && <div className="modalOverlay"></div>}
    </>;
}

export default ModalContent;